<template>
  <swiper
      :options="swiperOption"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
  >
    <swiper-slide v-for="item in bannerList" :key="item.id">
      <img
          class="img"
          :src="`${baseUrl}/${item.imgUrl}`"
          alt=""
          @click="openView(item.linkUrl)"
      />
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { getLogo } from '@/api';
import { openView } from '@/utils';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_URL,
      swiperOption: {
        slidesPerView: 1,
        // 设置分页器
        pagination: {
          el: '.swiper-pagination',
          // 设置点击可切换
          clickable: true,
        },
        // 设置自动轮播
        autoplay: {
          delay: 5000, // 5秒切换一次
        },
        // 匀速播放频率
        speed: 1000,
      },
      bannerList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    openView,
    async init() {
      const { code, result } = await getLogo({ type: 'banner2' });
      this.bannerList = result;
    },
    onSwiper(swiper) {
      console.log(swiper);
    },
    onSlideChange() {
      // console.log('slide change');
    },
  },
};
</script>

<style lang="scss" scoped>
.img {
  height: 344px;
  cursor: pointer;
}
</style>
